import { Link } from "react-router-dom";
import { Clock, MapPin, Ticket } from "lucide-react";

const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  "Carpe Diem Art & Learning Centre, Godinho House, Gomes Waddo, Majorda, South Goa 403713, India"
)}`;

export default function ExhibitionVisitPanel() {
  return (
    <div className="border border-soft bg-cream-2 p-6 space-y-5" data-testid="exhibition-visit-panel">
      <div className="overline">Plan your visit</div>
      <ul className="space-y-3 text-sm">
        <li className="flex items-start gap-3"><Clock size={16} className="text-sage mt-0.5" />
          <span><strong className="font-medium">Open Wed – Sun · 10 AM – 7 PM</strong><br /><span className="text-muted2">Closed Mondays &amp; Tuesdays</span></span>
        </li>
        <li className="flex items-start gap-3"><Ticket size={16} className="text-sage mt-0.5" />
          <span><strong className="font-medium">Free entry</strong> · no booking needed — just walk in</span>
        </li>
        <li className="flex items-start gap-3"><MapPin size={16} className="text-sage mt-0.5" />
          <span>Carpe Diem Art Gallery, Godinho House, Majorda, South Goa</span>
        </li>
      </ul>
      <div className="flex flex-wrap gap-3 pt-1">
        <a href={MAPS_DIRECTIONS} target="_blank" rel="noreferrer" className="btn-primary" data-testid="exhibition-directions">Get directions</a>
        <Link to="/contact" className="btn-ghost" data-testid="exhibition-contact">Contact us</Link>
      </div>
    </div>
  );
}
